import React from 'react'

import { Table, Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'

import StatusLabel from '../../../../components/quote/status/label'
import DateTimeTask from '../../../../components/job/status/datetime' /*TODO:QUOTE*/

const ButtonGroup = Button.Group

const rowKey = (row) => row.id.toString()

const Widget = (props) => {
  const columns = [
    {
      title: 'E-ID #',
      dataIndex: 'quote',
      render: (quote, record) => {
        return (
          <ButtonGroup>
            <Button
              onClick={() => props.viewMore(record.id)}
              size='small'
              style={{ color: '#40a9ff', orderColor: '#40a9ff' }}
              icon={<EditOutlined />}
            >
              {record.externalId}
            </Button>
          </ButtonGroup>
        )
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 140,
      render: (text) => <StatusLabel status={text} />
    },
    { title: 'Name', dataIndex: 'name', key: 'name', ellipsis: true },
    {
      title: 'Client/Project',
      dataIndex: 'client',
      key: 'client',
      render: (client, record) => {
        return ''
        if (record.pointOfSale) {
          return (
            <>
              {props.pointOfSalesById[record.pointOfSale]?.name} (
              {props.projectsById[record.project]?.name})
            </>
          )
        } else if (record.project) {
          return <>{props.projectsById[record.project]?.name}</>
        } else {
          return <>{props.clientsById[client]?.name}</>
        }
      }
    },
    {
      title: 'Deadline',
      dataIndex: 'clientDeadlineAt',
      key: 'deadlineAt',
      render: (deadlineAt, record) => <DateTimeTask value={deadlineAt} status={record.status} />
    }
  ]

  return (
    <Table columns={columns} dataSource={props.list} size='small' pagination={false} rowKey={rowKey} />
  )
}

export default Widget
